import { useDidUpdateEffect } from '../../hooks/useDidUpdateEffect';
import { useParams, useSearchParams } from 'react-router-dom';
import { SEARCH_PARAM_KEY_PAGE_NUMBER, SEARCH_PARAM_KEY_TYPE } from '../constants/searchParamKeys';
export const DLCustomPageViewEvent = () => {
    const { handle, medium } = useParams();
    const [searchParams] = useSearchParams();
    const page = searchParams.get(SEARCH_PARAM_KEY_PAGE_NUMBER);
    const type = searchParams.get(SEARCH_PARAM_KEY_TYPE);
    useDidUpdateEffect(() => {
        window.dataLayer.push({
            event: 'custom_page_view'
        });
    }, [handle, medium, page, type]);
    return null;
};
